import { api } from './api';
import { VehicleResearchResponse } from '../types/vehicle';
import { useStore } from '../store/store';
import { Vehicle } from '../models/Vehicle';
import { Tunings } from '../enums/Tunings';
import { VehicleModulesResearchResponse } from '../models/response/VehicleModulesResearchResponse';
import { SetTuningResponse } from '../models/response/SetTuningResponse';
import { TuningInfoDto, TuningWraperDto } from '../models/TuningDto';
import toast from 'react-hot-toast';

export interface StickerDto {
    id?: string | null;
    localId: number;
    shape: number;
}

export interface StickerGroupDto {
    id?: string | null;
    name?: string | null;
    stickerIds: number[];
}

export interface VinylData {
    id?: string | null;
    name?: string | null;
    stickers: StickerDto[];
    groups: StickerGroupDto[];
    price: number;
    pricePerSticker: number;
}


export interface SaveVinylRequest {
    vehicleId: number;
    name: string;
    stickers: SaveStickerDto[];
    groups: SaveStickerGroupsDto[];
}

export interface SaveStickerGroupsDto {
    id: number;
    name: string;
    stickerIds: number[];
}

export interface SaveStickerDto {
    id: number;
    t: number;
    x: number;
    y: number;
    sx: number;
    sy: number;
    r: number;
    c: string;
    z: number;
}

export class VinylService {

    static async requestSetVinylEditorHtmlPage(vehicleId: number, vinylLocalId: number): Promise<void> {
        await api.post('/vinyls/editorHtmlPage/set', { vehicleId, vinylLocalId });
    }

    static async saveVinyl(request: SaveVinylRequest): Promise<void> {
        await api.post('/vinyl/buy', request);
    }

    static async equipVinyl(vehicleId: number, vinylLocalId: number): Promise<void> {
        await api.post('/vinyl/equip', { vehicleId, vinylLocalId });
    }

    static async setMenuVinyl(vehicleId: number, vinylLocalId: number): Promise<void> {
        await api.post('/vinyl/menu/set', { vehicleId, vinylLocalId });
    }

    static async getVinylData(vehicleId: number, vinylLocalId: number): Promise<VinylData> {
        const response = await api.get(`/vinyl?vehicleId=${vehicleId}&vinylLocalId=${vinylLocalId}`);
        return response.data as VinylData;
    }
} 